import { FilledIcon, OutlinedIcon } from '@one/icons';
import { PocIcon } from 'commons/components/components-wrapper';
import { BulkActionButtonStyled } from './bulk-action-button.style';

interface BulkActionButtonComponentProps {
    onClick: () => void;
    disabled?: boolean;
    className?: string;
    iconName?: FilledIcon | OutlinedIcon;
    text?: string;
}

export const BulkActionButtonComponent: React.FC<BulkActionButtonComponentProps> = ({
    onClick,
    className,
    disabled = false,
    iconName,
    text,
}) => (
    <BulkActionButtonStyled
        className={`${disabled ? 'disabled' : ''} ${className}`}
        variant="tertiary"
        size="medium"
        onClick={onClick}
    >
        <PocIcon slot="prefix" name={iconName} family="outlined" />
        {text}
    </BulkActionButtonStyled>
);
